export default {
  black:"#5D71A2",
  purple: {
    "50": "#EFE5FF",
    "100": "#D3B8FF",
    "200": "#B68AFF",
    "300": "#9A5CFF",
    "400": "#7D2EFF",
    "500": "#6100FF",
    "600": "#4D00CC",
    "700": "#3A0099",
    "800": "#270066",
    "900": "#130033",
  },
  pink: {
    "50": "#FCE8F4",
    "100": "#F8BFE1",
    "200": "#F395CD",
    "300": "#EF6CBA",
    "400": "#EA42A7",
    "500": "#E61993",
    "600": "#B81476",
    "700": "#8A0F58",
    "800": "#5C0A3B",
    "900": "#2E051D",
  },
  yellow: {
    "50": "#FEFDE6",
    "100": "#FDFBB9",
    "200": "#FCF88C",
    "300": "#FBF55F",
    "400": "#FAF233",
    "500": "#F9EF06",
    "600": "#C7BF05",
    "700": "#968F03",
    "800": "#646002",
    "900": "#323001",
  },
  gray: {
      "50": "#EFF1F6",
      "100": "#D2D7E5",
      "200": "#B4BED4",
      "300": "#97A4C3",
      "400": "#7A8AB3",
      "500": "#5D71A2",
      "600": "#4A5A82",
      "700": "#384461",
      "800": "#252D41",
      "900": "#131720"
    }
};
